import { render, staticRenderFns } from "./social-query.vue?vue&type=template&id=6fb43996"
import script from "./social-query.vue?vue&type=script&lang=ts"
export * from "./social-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports